// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 643 ? "d70a52fe" : chunkId) + "." + {"307":"5a8d5c1913bfbab5","643":"4e87112a86ce2291"}[chunkId] + ".js";
};